/// <reference path="../../scripts/typings/vrview/index.d.ts" />


module Cfnc {

    interface ICfncVRViewAttributes extends angular.IAttributes {
        id: string;
        width: string;
        height: string;
        isStereo: boolean;
    }

    interface ICfncVRViewScope extends angular.IScope {
        playing: boolean;
        volume: number;
        mute: boolean;
        play: () => void;
        setVolume: () => void;
        muteVolume: () => void;
        vrView: any;
        src: string;
        isReady: boolean;
        init: () => void;
    }

    class CfncVRView implements ng.IDirective {
        static directiveId: string = "cfncVrview";
        restrict: string = "E";
        template: string = `<div id="vrview{{$id}}" class="vr-view">
                                <div class="controls-container" ng-if="isReady">
                                    <button class="vr-play btn btn-link fa fa-fw" ng-class="{ 'icon-play': !playing, 'icon-pause': playing}" ng-click="play()"></button>
                                    <button class="vr-mute btn btn-link fa fa-fw" ng-class="{ 'icon-volume-off': volume==0 || mute==true, 'icon-volume-down': volume<=50, 'icon-volume-up': volume>50}" ng-click="muteVolume()"></button>
                                    <input type="range" ng-model="volume" min="0" max="100" ng-change="setVolume()">
                                </div>
                            </div>`;
        replace: boolean = true;
        scope: any = {
            src: "="
        }

        constructor() { }

        link = (scope: ICfncVRViewScope, element: angular.IAugmentedJQuery, attrs: ICfncVRViewAttributes) => {
            scope.playing = false;
            scope.volume = 100;
            scope.mute = false;
            scope.isReady = false;


            angular.element('document').ready(() => {
                scope.vrView = new VRView.Player("#" + attrs.id, {
                    video: scope.src,
                    is_stereo: attrs.isStereo ? attrs.isStereo : false,
                    width: attrs.width ? attrs.width : "100%",
                    height: attrs.height ? attrs.height : "100%"
                });

                scope.vrView.on('ready', () => {
                    scope.playing = true;
                    scope.isReady = true;
                    scope.$applyAsync();
                });
            });



            scope.play = () => {
                console.log(scope.vrView.getCurrentTime());
                if (scope.playing) {
                    scope.vrView.pause();
                    scope.playing = false;

                }
                else {
                    scope.vrView.play();
                    scope.playing = true;
                }
            };

            scope.setVolume = () => {
                console.log(scope.vrView);
                if (scope.vrView) {
                    scope.mute = false;
                    scope.vrView.setVolume(scope.volume / 100);
                }
            };

            scope.muteVolume = () => {
                scope.mute = !scope.mute;

                if (scope.vrView) {
                    if (scope.mute) {

                        scope.vrView.setVolume(0);
                    } else {
                        scope.vrView.setVolume(scope.volume / 100);
                    }
                }
            }


            scope.$watch("src", (newValue: string, oldValue: string) => {
                if (scope.vrView != null) {
                    scope.vrView.setContent({
                        video: newValue,
                        is_stereo: attrs.isStereo ? attrs.isStereo : false
                    });
                    scope.vrView.play();
                    scope.playing = true;
                }
            });

           
        }
    }

    angular.module("app").directive(CfncVRView.directiveId, [() => new CfncVRView()]);
}